export const RQ_GET_MARKETING_ACTIVITY_REPORTS_API = {
  url:'visitmarketingactivity/report/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};
